export const text = {
  forgotPasswordTitle: "Forgot Password",
  forgotPasswordHeading: "Forgot Password?",
  forgotPasswordDescription:
    "If you forgot your password, well, then we’ll email you instructions to reset your password.",
  email: "Email Address",
  emailPlaceholder: "Enter Email Address",
  submit: "Send",
  backTo: "Back to Sign In",
};
